var render = function () {
  var _vm$notification, _vm$notification2, _vm$notification3, _vm$notification4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-container"
  }, [_c('table', {
    staticClass: "board-view"
  }, [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s((_vm$notification = _vm.notification) === null || _vm$notification === void 0 ? void 0 : _vm$notification.subject))])]), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("작성자 : 관리자")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("작성일 : " + _vm._s(_vm.$dayjs((_vm$notification2 = _vm.notification) === null || _vm$notification2 === void 0 ? void 0 : _vm$notification2.createdAt).format("YYYY-MM-DD HH:mm:ss")))])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("조회수 : " + _vm._s((_vm$notification3 = _vm.notification) === null || _vm$notification3 === void 0 ? void 0 : _vm$notification3.viewCount))])])], 1)], 1)]), _c('tr', [_c('td', {
    staticClass: "content_box",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm$notification4 = _vm.notification) === null || _vm$notification4 === void 0 ? void 0 : _vm$notification4.content.replace(/\n/g, '<br>'))
    }
  })])])]), _c('v-row', {
    staticClass: "mt--md justify-end"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pt-36 pt-md-54 pt-lg-74"
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "grey lighten-3"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/service/notice');
      }
    }
  }, [_c('span', {
    staticClass: "font-weight-medium font-pretendard grey--text"
  }, [_vm._v("LIST")])])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }